module.exports = __webpack_public_path__ + "img/about-bio-3.16b7f741.jpg";